import { getAdminGigApplicationsListQueryOptions } from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";
import * as z from "zod/mini";
import { APPLICATION_PARAMS_DEFAULT, type ApplicationParams, applicationParamsSchema } from "./routing";

type Context = { proId?: number; gigId?: number };
type QueriesInput = Context & { search: { applicationParams?: unknown } };

export const withContext = (params: ApplicationParams, { proId, gigId }: Context): ApplicationParams => ({
  ...params,
  ...(proId ? { pro_id: proId } : {}),
  ...(gigId ? { gig_id: gigId } : {}),
});

export const toApplicationParams = (raw: unknown, context: Context) =>
  withContext(z.catch(applicationParamsSchema, APPLICATION_PARAMS_DEFAULT).parse(raw), context);

export const applicationsQuery = (params: ApplicationParams) => getAdminGigApplicationsListQueryOptions(params);

export const queries = ({ search, ...context }: QueriesInput): Array<WarmableQuery> => [
  applicationsQuery(toApplicationParams(search.applicationParams, context)),
];
